import { type Label, BuiltInLabels } from "building-types/entities/labelTypes";
import type { Table } from "common/data/table";
import { camelCaseToTitleCase } from "common/utils/strings";
import { labelNew } from "../elements/labelNew";

export function defaultLabelTable(): Table<Label> {
  return BuiltInLabels.reduce((table, label) => {
    table[label] = labelNew({ id: label, name: camelCaseToTitleCase(label) });
    return table;
  }, {});
}
